export const interpolate = (
  str: string,
  parameters: { [key: string]: unknown } = {}
) =>
  str.replace(
    /\{([^}]+)\}/g,
    (match, name) => String(parameters[name]) || match
  )
